<template>
  <div>
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherDatetimeRangeWithRadio
                v-model="options"
                type="datetime"
                show-radios
                :radios="datetimeRadios"
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <!-- 批量导出 -->
              <v-btn
                small
                color="print"
                dark
                class="ms-1"
                @click.stop="exportExcelDialog = true"
              >
                {{ $t("MaterialAnalyze.Fields.batch_export") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <!-- 商品分类 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherSupplierMaterialCategories
                    v-model="materialCategoriesSelected"
                  />
                </v-col>
                <!-- 商品 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherMaterials
                    v-model="materialSelected"
                    :material-categories="materialCategoriesSelected"
                  />
                </v-col>
                <!-- 客户名称 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="keyword"
                    v-model="options.keyword"
                    @text="Keyword = $event"
                    :label="$consts.shopName()"
                  />
                </v-col>
                <!-- 供货编码 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="supplyCode"
                    v-model="options.supply_code"
                    @text="supplyCode = $event"
                    :label="$t('Materials.Fields.supply_code')"
                  />
                </v-col>
                <!-- 统计类型 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherSingleStatus
                    v-model="options.type"
                    :label="$t('MaterialAnalyze.statisticalType.title')"
                    :items="$consts.statisticalType"
                  />
                </v-col>
                <!-- 发货状态 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherSingleStatus
                    v-model="options.delivery_flg"
                    :label="$t('MaterialAnalyze.deliveryFlgs.title')"
                    :items="$consts.purchaseDeliverFlgs"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <!-- 表格 -->
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="supplier_material_analyze"
            :options.sync="options"
            :loading="loading"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-1 px-4 pt-1"
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>

            <!-- 合计 -->
            <template v-slot:body.prepend>
              <tr class="d-none d-sm-table-row">
                <td colspan="7">
                  <span>{{ $t("TableSum") }}</span>
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  {{ total_num | formatTwoDot }}
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  {{ $t("Global.money") }}
                  {{ total_price | formatMoney }}
                </td>
                <td></td>
              </tr>
              <tr class="d-table-row d-sm-none">
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("TableSum") }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("MaterialAnalyze.Fields.material_num_total") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ total_num | formatTwoDot }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("MaterialAnalyze.Fields.material_price_total") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money") }}
                    {{ total_price | formatMoney }}
                  </div>
                </td>
              </tr>
            </template>
            <!-- 按钮  -->
            <template v-slot:item.actions="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    v-bind="attrs"
                    v-on="on"
                    dark
                    color="info"
                    class="px-2 me-2"
                    :href="'/#/material-analyze/' + item.material_id"
                  >
                    <!-- <v-icon x-small class="pe-1">fa-align-left</v-icon> -->
                    {{ $t("Delivery.Fields.detail") }}
                  </v-btn>
                </template>
                <span>{{
                  $t("CRUD.viewInfo", [$t("Delivery.Fields.detail")])
                }}</span>
              </v-tooltip>
            </template>

            <template v-slot:item.average_price="{ item }">
              {{ $t("Global.money")
              }}{{ (item.total_price / item.total_num) | formatMoney }}
            </template>
            <template v-slot:item.total_num="{ item }">
              {{ item.total_num | formatTwoDot }}
            </template>
            <template v-slot:item.total_price="{ item }">
              {{ $t("Global.money") }}{{ item.total_price | formatMoney }}
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>

    <!-- 导出excel -->
    <v-dialog
      v-model="exportExcelDialog"
      max-width="40%"
      transition="dialog-top-transition"
    >
      <v-card>
        <v-card-title class="mx-3 d-flex justify-space-between">
          <!-- 无内容的span用于用于调整位置 -->
          <span></span>
          <span>
            {{ $t("MaterialAnalyze.remind") }}
          </span>

          <!-- <v-spacer></v-spacer> -->
          <v-tooltip disabled>
            <template v-slot:activator="{ on, attrs }" class="">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="
                  exportExcelDialog = false;
                  styleType = '1';
                "
              >fa-times
              </v-icon>
            </template>
          </v-tooltip>
        </v-card-title>
        <v-divider class="mb-4 mt-2" />
        <!-- excel样式展示 -->
        <v-card-text class="px-4 text-center">
          <v-row justify="center">
            <v-col class="pb-0">
              <v-row justify="center" class="pt-4">
                <v-col
                  cols="12"
                  sm="12"
                  md="2"
                  class="py-0 pr-0 d-flex justify-center align-center font-weight-bold subtitle-2"
                >
                  <div class="text-no-wrap" align="center">
                    {{ $t("MaterialAnalyze.style_one") + $t("Global.colon") }}
                  </div>
                </v-col>
                <v-col cols="10" sm="10" md="9" class="py-0 pl-0 ma-0">
                  <v-img
                    lazy-src="../../assets/material_analyze_to_excel_style1.png"
                    :src="require('../../assets/' + $t('$assets.style1'))"
                    contain
                  ></v-img>
                </v-col>
              </v-row>
              <v-row justify="center" class="pb-4">
                <a
                  @click.stop="
                    $showFullscreenImages([
                      require('../../assets/' + $t('$assets.style1')),
                    ])
                  "
                  class="caption"
                >{{ $t("MaterialAnalyze.check") }}</a>
              </v-row>

              <v-divider class="my-4" />
              <v-row justify="center" class="pt-4">
                <v-col
                  cols="12"
                  sm="12"
                  md="2"
                  class="py-0 d-flex justify-center align-center font-weight-bold subtitle-2"
                >
                  <div class="text-no-wrap">
                    {{ $t("MaterialAnalyze.style_two") + $t("Global.colon") }}
                  </div>
                </v-col>
                <v-col cols="10" sm="10" md="9" class="py-0 pl-0 ma-0">
                  <v-img
                    lazy-src="../../assets/material_analyze_to_excel_style2.png"
                    :src="require('../../assets/' + $t('$assets.style2'))"
                    contain
                  ></v-img>
                </v-col>
              </v-row>
              <v-row justify="center" class="pb-4">
                <a
                  @click.stop="
                    $showFullscreenImages([
                      require('../../assets/' + $t('$assets.style2')),
                    ])
                  "
                  class="caption"
                >{{ $t("MaterialAnalyze.check") }}</a>
              </v-row>

              <v-divider class="my-4" />
              <!-- 样式选择 -->
              <v-row justify="center" class="py-0">
                <v-radio-group v-model="styleType" row>
                  <v-radio
                    :label="$t('MaterialAnalyze.style_one')"
                    value="1"
                  ></v-radio>
                  <v-radio
                    :label="$t('MaterialAnalyze.style_two')"
                    value="2"
                  ></v-radio>
                </v-radio-group>
              </v-row>

              <v-divider class="mt-4" />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-end pb-4">
          <v-btn
                  @click="
              exportExcelDialog = false;
              styleType = '1';
            "
          >{{ $t("MaterialAnalyze.close") }}</v-btn
          >
          <v-btn @click.stop="BatchExport()" color="print" dark>{{
            $t("MaterialAnalyze.download")
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherSupplierMaterialCategories from "@/components/plugins/SearcherSupplierMaterialCategories";
import SearcherMaterials from "@/components/plugins/SearcherMaterials";
import MaterialAnalyze from "@/api/material_analyze";

import SearcherSingleStatus from "@/components/plugins/SearcherSingleStatus";

const defaultOptions = {
  datetimeRadioSelected: "create",
  create_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  create_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  delivery_time_from: "",
  delivery_time_to: "",
  keyword: "",
  delivery_flg: 0,
  type: 2,
  supplyCode: "",
};

export default {
  data: () => ({
    Keyword: "",
    supplyCode: "",
    supplier_material_analyze: [],
    category_ids: [],
    material_ids: [],
    paging: {},
    options: JSON.parse(JSON.stringify(defaultOptions)),
    loading: false,
    materialSelected: [],
    materialCategoriesSelected: [],
    total_num: 0,
    total_price: 0,
    exportExcelDialog: false,
    styleType: "1",
  }),
  components: {
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    SearcherKeyword,
    SearcherSupplierMaterialCategories,
    SearcherMaterials,
    SearcherSingleStatus,
  },
  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.reportCenter"),
        disabled: false,
        href: "/material-analyze",
      },
      {
        text: i18n.t("Nav.materialAnalyze"),
        disabled: true,
        href: "/material-analyze",
      },
    ],
    datetimeRadios() {
      var datetimeRadios = [
        {
          key: "create",
          text: i18n.t("Delivery.Fields.created_time"),
        },
        {
          key: "delivery",
          text: i18n.t("MaterialAnalyze.Fields.delivery_date"),
          disabled: this.options.delivery_flg == 1 ? false : true,
        },
      ];
      return datetimeRadios;
    },
    headers: () => [
      {
        text: i18n.t("MaterialAnalyze.Fields.category_name"),
        align: "start",
        sortable: false,
        value: "category_name",
      },
      {
        text: i18n.t("MaterialAnalyze.Fields.material_code"),
        align: "start",
        sortable: false,
        value: "material_code",
      },
      {
        text: i18n.t("Materials.Fields.supply_code"),
        align: "start",
        sortable: false,
        value: "supply_code",
      },
      {
        text: i18n.t("MaterialAnalyze.Fields.material_name"),
        align: "start",
        sortable: false,
        value: "material_name",
      },
      {
        text: i18n.t("MaterialAnalyze.Fields.standards"),
        align: "start",
        sortable: false,
        value: "standard_name",
      },
      {
        text: i18n.t("MaterialAnalyze.Fields.average_price"),
        align: "end",
        sortable: false,
        value: "average_price",
      },
      {
        text: i18n.t("MaterialAnalyze.Fields.unit"),
        align: "start",
        sortable: false,
        value: "unit",
      },
      {
        text: i18n.t("MaterialAnalyze.Fields.total_num"),
        align: "end",
        sortable: false,
        value: "total_num",
      },
      {
        text: i18n.t("MaterialAnalyze.Fields.price"),
        align: "end",
        sortable: false,
        value: "total_price",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],
    ...mapState(["accountUser", "supplierId"]),
  },

  mounted() {
    this.$commonUtils
      .loadOptions("material_analyze", [
        "materialCategoriesSelected",
        "materialSelected",
      ])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
          } else this.resetSearch();
          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "materialCategoriesSelected":
                this.materialCategoriesSelected = selected.value;
                break;
              case "materialSelected":
                this.materialSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },

  methods: {
    onSearch() {
      this.options = Object.assign(this.options, {
        keyword: this.Keyword,
        supply_code: this.supplyCode
      });
      this.getMaterialAnalyzeFromAPI();
    },
    resetSearch() {
      this.materialCategoriesSelected = [];
      this.materialSelected = [];

      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },

    getMaterialAnalyzeFromAPI() {
      this.loading = true;
      MaterialAnalyze.fetch(
        this.$store.getters.supplierId,
        Object.assign(this.options, { detail_flg: 0 })
      ).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.supplier_material_analyze =
              response.data.supplier_material_analyze;
            this.total_num = response.data.total_num;
            this.total_price = response.data.total_price;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },
    BatchExport() {
      MaterialAnalyze.batchExport(
        this.$store.getters.supplierId,
        Object.assign(this.options, {
          style: this.styleType
        })
      );
    },
  },

  watch: {
    supplierId: {
      handler() {
        this.getMaterialAnalyzeFromAPI();
      },
    },
    options: {
      deep: true,
      handler() {
        if (this.options.delivery_flg != 1) {
          if (this.options.datetimeRadioSelected == "delivery") {
            this.options.datetimeRadioSelected = "create";
            this.options.create_time_from =
              new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
                .toISOString()
                .substr(0, 10) + " 00:00:00";
            this.options.create_time_to =
              new Date().toISOString().substr(0, 10) + " 23:59:59";
          }
        }
        this.getMaterialAnalyzeFromAPI();
        sessionStorage.setItem(
          "material_analyze-options",
          JSON.stringify(this.options)
        );
      },
    },
    // 商品分类
    materialCategoriesSelected: {
      handler() {
        this.options.category_ids = this.materialCategoriesSelected
          ? this.materialCategoriesSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          "material_analyze-materialCategoriesSelected",
          JSON.stringify(this.materialCategoriesSelected)
        );
      },
    },

    // 商品
    materialSelected: {
      handler() {
        this.options.material_ids = this.materialSelected
          ? this.materialSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          "material_analyze-materialSelected",
          JSON.stringify(this.materialSelected)
        );
      },
    },
  },
};
</script>

<style>
</style>